var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8031 1.04199C5.85551 1.04199 1.84473 5.05277 1.84473 10.0003C1.84473 14.9479 5.85551 18.9587 10.8031 18.9587C15.7506 18.9587 19.7614 14.9479 19.7614 10.0003C19.7614 5.05277 15.7506 1.04199 10.8031 1.04199ZM11.6364 6.66699C11.6364 6.20676 11.2633 5.83366 10.8031 5.83366C10.3428 5.83366 9.96973 6.20676 9.96973 6.66699V10.0003C9.96973 10.2213 10.0576 10.4333 10.2138 10.5896L11.8805 12.2562C12.2059 12.5817 12.7336 12.5817 13.059 12.2562C13.3844 11.9308 13.3844 11.4032 13.059 11.0777L11.6364 9.65516V6.66699Z",
    fill: "#001E60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clock-blue.93fe6bfa055d7c3457e0254a3068d614.svg";
export { ForwardRef as ReactComponent };